export default function PHP_else() {
  return (
    <div>
      <h1>PHP_else</h1>
    </div>
  );
}
